/**
 * @module views\psm\inventory
 */
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Inventory extends Vue {}
